export default "__VITE_ASSET__bolIK51h__"